import { useSelector } from "@nf/common";
import { useCallback, useMemo } from "react";

export const useSubscriptionOffer = () => {
  const { currentOffer } = useSelector((state) => state.payment);

  const paymentsAreLoading: boolean = useMemo(() => {
    return (
      currentOffer &&
      Object.keys(currentOffer).some(
        // @ts-ignore
        (offer) => currentOffer[offer].IsProcessing
      )
    );
  }, [currentOffer]);

  const getOffer = useCallback(
    (id: string) => {
      // @ts-ignore
      return currentOffer && currentOffer[id] && currentOffer[id].Data;
    },
    [currentOffer]
  );

  return {
    currentOffer,
    paymentsAreLoading,
    getOffer,
  };
};
